import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthProvider.js';
import { ApiError } from '../api/client.js';
import { ThemeToggle } from '../components/ThemeToggle.js';

export function LoginPage() {
  const { login } = useAuth();
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [hint, setHint] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setHint(null);
    setSubmitting(true);
    try {
      await login(userid, password);
    } catch (err) {
      if (err instanceof ApiError && err.code === 'PASSWORD_UNUSABLE') {
        setError(err.message);
        setHint('서버에서 `npm run set-password -- ' + userid + '` 로 비밀번호를 넣을 수 있습니다.');
      } else {
        setError(err instanceof Error ? err.message : '로그인에 실패했습니다.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login">
      <div className="login__theme-toggle">
        <ThemeToggle />
      </div>
      <form className="login__card" onSubmit={onSubmit}>
        <h1 className="login__title">xadmin</h1>
        <p className="login__sub">관리자 로그인</p>

        <label className="field">
          <span className="field__label">아이디</span>
          <input
            className="input"
            value={userid}
            onChange={(e) => setUserid(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <label className="field">
          <span className="field__label">비밀번호</span>
          <input
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error && (
          <div className="state state--error" role="alert">
            <span>{error}</span>
            {hint && <code className="login__hint">{hint}</code>}
          </div>
        )}

        <button className="btn btn--primary btn--block" type="submit" disabled={submitting}>
          {submitting ? '확인 중…' : '로그인'}
        </button>
      </form>
    </div>
  );
}
